
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"10","viewBox":"0 0 15 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.266644 2.98385C0.605568 2.65623 1.1368 2.67515 1.45318 3.02611C2.15588 3.8056 4.42285 5.51136 7.46764 5.51136C10.5061 5.51136 12.8219 3.77757 13.5712 3.01293C13.9015 2.67593 14.433 2.67995 14.7584 3.02191C15.0839 3.36387 15.08 3.91427 14.7498 4.25128C13.8035 5.21697 11.0881 7.25 7.46764 7.25C3.85347 7.25 1.16733 5.25691 0.225835 4.21253C-0.0905498 3.86157 -0.0722786 3.31147 0.266644 2.98385Z","fill":"#EE7F1A"}})])
          )
        }
      }
    